<template>
  <div class="hall-page" v-if="event">
    <div class="hall-layout">
      <img class="screen-img" src="@/assets/screen.png" alt="screen">
      <cinema-seats
        v-if="event.hallType === 'CINEMA'"
        :seat-list="event.seatList"
        :low-price="event.lowPrice"
        :standart-price="event.standartPrice"
        :premium-price="event.premiumPrice">
      </cinema-seats>
      <hall-seats
        v-if="event.hallType === 'CONCERT'"
        :seat-list="event.seatList"
        :low-price="event.lowPrice"
        :standart-price="event.standartPrice"
        :premium-price="event.premiumPrice">

      </hall-seats>
    </div>
    <div class="event-layout animate__animated animate__fadeInRight">
      <div class="event-wrapper">
        <div class="beel-logo">
          <img src="@/assets/beel_logo.png" alt="logo">
        </div>
        <div class="event-info">
          <img class="event-image" :src="getServerUrl() + event.image.path" alt="event-image">
          <div class="event-title">
            {{ event.name }}
          </div>
          <div class="event-date">
            {{ getEventDate }}
          </div>
          <div class="event-description">
            {{ event.description }}
          </div>
        </div>
      </div>
      <div class="order-wrapper">
        <custom-button
          buttonText="Book"
          button-type="apply"
          :is-blocked="isButtonBlocked"
          @clicked="openForm">

        </custom-button>
      </div>
    </div>
    <InfoLabel
      label1="Доступно"
      label2="Занято"
      label3="Выбрано"
    ></InfoLabel>
  </div>
</template>

<script>
import axios from 'axios'
import Calendar from './CalendarComponent/Calendar.vue'
import CustomButton from './Inputs/CustomButton.vue'
import moment from 'moment/moment'
import {EventBus} from '@/eventBus'
import InfoLabel from './InfoLabel.vue'
import CinemaSeats from './Seats/CinemaSeats.vue'
import HallSeats from './Seats/HallSeats.vue'
import apiClient from "../../apiClient";
import {getServerUrl} from "../../globalConfig";

export default {
  name: 'HallPage',
  props: ['eventId'],
  components: {HallSeats, CinemaSeats, InfoLabel, CustomButton, Calendar},
  data () {
    return {
      event: null
    }
  },
  computed: {
    getEventDate () {
      return moment(this.event.startDate, 'YYYY-MM-DD HH:mm').format('DD MMM yyyy в HH:mm')
    },
    isButtonBlocked () {
      return !this.$store.state.selectedSeatSet.size > 0
    }
  },
  created: function () {
    let that = this

    apiClient.get('/api/event/' + this.eventId).then(function (response) {
      that.event = response.data
    })
  },
  methods: {
    getServerUrl,
    openForm () {
      let data = {
        bookingType: 'EVENT-CINEMA',
        bookingData: {
          event: this.event
        }
      }
      EventBus.$emit('openForm', data)
    }
  }
}
</script>

<style scoped>
.hall-page {
  display: flex;
  flex-direction: row;
}

.hall-layout {
  width: 77%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
}

.screen-img {
  width: 70%;
}

.event-layout {
  position: absolute;
  top: 0;
  left: 77%;
  width: 23%;
  height: 100vh;
  border-radius: 20px 0 0 20px;
  border-left: 0 solid #F1F1F1;
  background: #FFF;
  box-shadow: 0 8px 8px -4px rgba(16, 24, 40, 0.03), 0 20px 24px -4px rgba(16, 24, 40, 0.08);
  display: flex;
  flex-direction: column;
}

.event-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 32px 16px;
    height: 100%;
}

.event-info {
  padding-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: #101828;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.event-image {
  width: 100%;
}

.event-title {
  color: #101828;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
}

.order-wrapper {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.price {
  color: #344054;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/client/HallPage.vue